var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container mx-auto text-center max-w-lg"},[_c('div',{staticClass:"px-3 py-2"},[_c('h2',{domProps:{"textContent":_vm._s(_vm.$t('DELIVERY_ADDRESS_WHO_ARE'))}})])]),_c('gifting-addresses-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }